/**
 * @author gabyong.kim
 * @email gabyong.kim@gloovir.com
 * @create date 2023-11-28 18:29:45
 * @modify date 2023-11-28 18:29:45
 * @desc [description]
 */

import { useEffect, useState } from "react";
import { SmtpMgmtData, initSmtpMgmtData } from "./SmtpMgmtData";
import { useTranslation } from "react-i18next";
import { PLATFORM_URL } from "value/Url";
import { requests } from "common/RestAPI";
import { View, Text, StyleSheet, Pressable } from "react-native";
import { ReactComponent as MsgInfoImg } from '../../../img/ico-msg-info-2.svg';
import { FONT } from "value/staticValues";
import { CustomTextInput } from "components/base/CustomInputText";
import CustomText from "components/base/CustomText";
import { ReactComponent as InActiveCheckBoxImg } from '../../../img/btn-checkbox-incon-circle-inactive.svg';
import { ReactComponent as ActiveCheckBoxImg } from '../../../img/btn-checkbox-incon-circle-active.svg';



interface SmtpMgmtUpdateProps {
  showMessageCb?: Function,
  showLoadingCb?: Function,
  stepIndex: number,
  clickedConfirmYn: boolean,
  resultCb?: Function,
  stepCount: number,
  args?: SmtpMgmtData,
};



export default function SmtpMgmtUpdate(props:SmtpMgmtUpdateProps) {
  const { t } = useTranslation();

  const [senderEmail, setSenderEmail] = useState<string>(props.args?.smtp_sender_address || "");
  const [senderName, setSenderName] = useState<string>(props.args?.smtp_sender_name || "");
  const [smtpPrefix, setSmtpPrefix] = useState<string>(props.args?.smtp_prefix || "");
  const [serverHost, setServerHost] = useState<string>(props.args?.smtp_host || "");
  const [serverPort, setServerPort] = useState<string>(props.args?.smtp_port || "");
  const [accountName, setAccountName] = useState<string>(props.args?.smtp_username || "");
  const [accountPassword, setAccountPassword] = useState<string>("");
  const [supportMail, setSupportMail] = useState<string>(props.args?.support_manager || "");
  const [tlsYn, setTlsYn] = useState<boolean>(props.args?.smtp_tls_yn || false);

  const [stepIndex, setStepIndex] = useState(0);
  const [executeUpdateYn, setExecuteUpdateYn] = useState(false);


  useEffect(() => {
    if(props.showMessageCb) {
        props.showMessageCb("");
    }
    setStepIndex(props.stepIndex);

  }, [props.stepIndex]);


  useEffect(() => {
    if(props.clickedConfirmYn === true) {
      if(stepIndex < props.stepCount - 1) {

      } else {
        const successYn = checkSmtpData();
        if(successYn) {
          executeUpdateSmtp();
        } else {
          executeResult({successYn: false}, false, '');;
        }
      }
    }
  }, [props.clickedConfirmYn])



  function checkSmtpData() {
    let message = "";
    let error = false;

    if (!senderEmail || !senderName || !smtpPrefix) {
      message = t("MENU_APPLICATION_SMTP_ERROR_INPUT_SENDER_INFO")
      error = true
    }

    if (!serverHost || !serverPort || !accountName || !accountPassword) {
      message = t("MENU_APPLICATION_SMTP_ERROR_INPUT_SETTINGS_INFO")
      error = true
    }

    if (!supportMail) {
      message = t("MENU_APPLICATION_SMTP_ERROR_INPUT_SUPPORT_MAIL")
      error = true
    }

    if(error === true)
      if(props.showMessageCb){
        props.showMessageCb(message);
    }

    return !error;
  }



  function executeResult(result, closeYn, infoMessage) {
    setExecuteUpdateYn(false);
    if(props.showMessageCb && infoMessage) {
        props.showMessageCb(infoMessage);
    }
    if(props.resultCb) {
        props.resultCb(result, closeYn);
    }
  }


  function executeUpdateSmtp() {

    const body = {
      system_smtp: {
        smtp_sender_address: senderEmail,
        smtp_sender_name: senderName,
        smtp_prefix: smtpPrefix,
        smtp_host: serverHost,
        smtp_port: serverPort,
        smtp_username: accountName,
        smtp_password: accountPassword,
        smtp_tls_yn: tlsYn ? true : false,
        support_manager: supportMail
      }
    }

    requests.post(PLATFORM_URL.SMTP, body)
    .then((response) => {
      if(response.status === 200) {
          executeResult({successYn: true }, true, "");
      } else {
          executeResult({successYn: false}, false, t("MESSAGE_CANNOT_COMMIT_DATA_MESSAGE"));
      }
    })
    .catch((error) => {
        executeResult({successYn: false}, false, t("MESSAGE_CANNOT_COMMIT_DATA_MESSAGE"));
    });
  }


  return (
    <View>
      {
        stepIndex === 0
        &&
        <View>
          <Text style={style.titleText}>{
            t("MENU_APPLICATION_SMTP_UPDATE_SENDER_TITLE")}
          </Text>

          <View style={{marginTop: 38}}>

            {/* SMTP 보낸 이메일 */}
            <View style={style.rowContainer}>
              <CustomText text={t("MENU_APPLICATION_SMTP_SEND_EMAIL")} fontStyle={style.columnText} asterisk={true}/>
              <View>
                <CustomTextInput
                    width={450} height={36}
                    value={senderEmail}
                    type={"text"}
                    activeYn={true}
                    inputCb={(v)=>{setSenderEmail(v)}}
                    warnYn={false}
                    placeHolderText={t("")}
                />
                <Text style={{fontSize: 10, lineHeight: 12, color: '#252525', fontFamily: FONT.LIGHT, marginTop: 5}}>
                  {t("MENU_APPLICATION_SMTP_UPDATE_SENDER_EMAIL_GUIDE")}
                </Text>
              </View>
            </View>


            {/* SMTP 보낸 이름 */}
            <View style={style.rowContainer}>
              <CustomText text={t("MENU_APPLICATION_SMTP_SEND_NAME")} fontStyle={style.columnText} asterisk={true}/>
              <View>
                <CustomTextInput
                    width={450} height={36}
                    value={senderName}
                    type={"text"}
                    activeYn={true}
                    inputCb={(v)=>{setSenderName(v)}}
                    warnYn={false}
                    placeHolderText={t("")}
                />
                <Text style={{fontSize: 10, lineHeight: 12, color: '#252525', fontFamily: FONT.LIGHT, marginTop: 5}}>
                  {t("MENU_APPLICATION_SMTP_UPDATE_SENDER_NAME_GUIDE")}
                </Text>
              </View>
            </View>


            {/* SMTP 보낸 이름 */}
            <View style={style.rowContainer}>
              <CustomText text={t("MENU_APPLICATION_SMTP_TITLE_PREFIX")} fontStyle={style.columnText} asterisk={true}/>
              <View>
                <CustomTextInput
                    width={450} height={36}
                    value={smtpPrefix}
                    type={"text"}
                    activeYn={true}
                    inputCb={(v)=>{setSmtpPrefix(v)}}
                    warnYn={false}
                    placeHolderText={t("")}
                />
                <Text style={{fontSize: 10, lineHeight: 12, color: '#252525', fontFamily: FONT.LIGHT, marginTop: 5}}>
                  {t("MENU_APPLICATION_SMTP_UPDATE_SMTP_PREFIX_GUIDE")}
                </Text>
              </View>
            </View>
          </View>


        <div style={{borderWidth: 1, border: "solid 0.5px #eee", marginTop: 30}}/>

        <Text style={style.titleText}>{
          t("MENU_APPLICATION_SMTP_UPDATE_SETTINGS_TITLE")}
        </Text>

        <View style={{marginTop: 38}}>

          {/* 서버 호스트 */}
          <View style={style.rowContainer}>
            <CustomText text={t("MENU_APPLICATION_SMTP_SERVER_HOST")} fontStyle={style.columnText} asterisk={true}/>
            <View>
              <CustomTextInput
                  width={450} height={36}
                  value={serverHost}
                  type={"text"}
                  activeYn={true}
                  inputCb={(v)=>{setServerHost(v)}}
                  warnYn={false}
                  placeHolderText={t("")}
              />
            </View>
          </View>


          {/* 서버 포트 */}
          <View style={style.rowContainer}>
            <CustomText text={t("MENU_APPLICATION_SMTP_SERVER_PORT")} fontStyle={style.columnText} asterisk={true}/>
            <View style={{flexDirection: 'row'}}>
              <CustomTextInput
                  width={100} height={36}
                  value={serverPort}
                  type={"text"}
                  activeYn={true}
                  inputCb={(v)=>{setServerPort(v)}}
                  warnYn={false}
                  placeHolderText={t("")}
              />
               <Pressable style={{marginLeft: 10, flexDirection: 'row', alignItems: 'center'}} onPress={()=>setTlsYn(!tlsYn)}>
                  {(tlsYn) ? <ActiveCheckBoxImg/> : <InActiveCheckBoxImg/>}
                  <Text style={{...style.columnText, marginLeft: 8}}>
                    {t("MENU_APPLICATION_SMTP_SEND_TLS")}
                  </Text>
                </Pressable>
            </View>
          </View>


          {/* 계정 이름 */}
          <View style={style.rowContainer}>
            <CustomText text={t("MENU_APPLICATION_SMTP_ACCOUNT_NAME")} fontStyle={style.columnText} asterisk={true}/>
            <View>
              <CustomTextInput
                  width={450} height={36}
                  value={accountName}
                  type={"text"}
                  activeYn={true}
                  inputCb={(v)=>{setAccountName(v)}}
                  warnYn={false}
                  placeHolderText={t("")}
              />
            </View>
          </View>


          {/* 계정 비밀번호 */}
          <View style={style.rowContainer}>
            <CustomText text={t("MENU_APPLICATION_SMTP_ACCOUNT_PASSWORD")} fontStyle={style.columnText} asterisk={true}/>
            <View>
              <CustomTextInput
                  width={450} height={36}
                  value={accountPassword}
                  type={"password"}
                  activeYn={true}
                  inputCb={(v)=>{setAccountPassword(v)}}
                  warnYn={false}
                  placeHolderText={t("")}
              />
              <Text style={{fontSize: 10, lineHeight: 12, color: '#252525', fontFamily: FONT.LIGHT, marginTop: 5}}>
                {t("MENU_APPLICATION_SMTP_UPDATE_ACCOUT_PASSWORD_GUIDE")}
              </Text>
            </View>
          </View>
        </View>


        <div style={{borderWidth: 1, border: "solid 0.5px #eee", marginTop: 30}}/>


        <Text style={style.titleText}>{
          t("MENU_APPLICATION_SMTP_UPDATE_ALRAM_TITLE")}
        </Text>

        <View style={{marginTop: 38}}>

          {/* 문의 수신 이메일 */}
          <View style={style.rowContainer}>
            <CustomText text={t("MENU_APPLICATION_SMTP_RECEIVE_EMAIL")} fontStyle={style.columnText} asterisk={true}/>
            <View>
              <CustomTextInput
                  width={450} height={36}
                  value={supportMail}
                  type={"text"}
                  activeYn={true}
                  inputCb={(v)=>{setSupportMail(v)}}
                  warnYn={false}
                  placeHolderText={t("")}
              />
              <Text style={{fontSize: 10, lineHeight: 12, color: '#252525', fontFamily: FONT.LIGHT, marginTop: 5}}>
                {t("MENU_APPLICATION_SMTP_UPDATE_SUPPORT_EMAIL_GUIDE")}
              </Text>
            </View>
          </View>
        </View>
      </View>
      }
    </View>
  )
}



const style = StyleSheet.create({
  titleText: {
    marginTop: 40,
    fontFamily: FONT.MEDIUM,
    fontSize: 14,
    fontWeight: "500",
    color: "#0853fb",
  },
  rowContainer: {
    height: 36,
    flexDirection: "row",
    marginBottom: 30,
    alignItems: "center"
  },
  columnText: {
    width: 150,
    fontFamily: FONT.REGULAR,
    fontSize: 13,
    color: "#333",
  },
});



SmtpMgmtUpdate.defaultProps = {
  stepIndex: 0,
  clickedConfirmYn: false,
  stepCount: 1,
}



